// extracted by mini-css-extract-plugin
export default {"fullWidth":"dea-z","hasStyledAspectRatio":"eea-z"};